Vue.component('owl-carousel', {
  template: '#vue-owl-carousel',
  data: function () {
    return {
      elementHandle: 'carousel_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    }
  },
  props: {
    // slider
    items: { default: 1 },
    margin: { default: 0 },
    loop: { default: true },
    rewind: { default: false },
    center: { default: false },
    nav: { default: true },
    navText: {
      default: function () {
        return ["‹", "›"]
      }
    },
    navSpeed: { default: 600 },
    dots: { default: true },
    autoplay: { default: true },
    autoplayMobile: { default: false },
    autoplaySpeed: { default: 1400 },
    autoplayTimeout: { default: 7000 },
    autoplayHoverPause: { default: false },
    mouseDrag: { default: true },
    touchDrag: { default: true },
    pullDrag: { default: true },
    freeDrag: { default: false },
    dragEndSpeed: { default: 600 },
    stagePadding: { default: 0 },
    autoWidth: { default: false },
    autoHeight: { default: false },
    responsive: {
      default: function () {
        return {}
      }
    },
    lazyLoad: { default: true },
    lazyLoadEager: { default: 1 }
    //		smartSpeed: { default: 100000 },
    //		fluidSpeed: { default: 100000 },
    //		dotsSpeed: { default: 600 }
  },
  methods: {
    owlCarouselStart: function (i_max, i, $owl, $owlAttr) {
      const self = this;

      if (typeof i === 'undefined') i = 0;

      if (typeof $owl === 'undefined') {
        $owl = $('#' + self.elementHandle);
        $.extend($owlAttr, $owl.data("owl-carousel"));
      }

      if ($('.vSliderItemClass')[0]) {
        loadScript('/js/owl.carousel.min.js', function () {
          if (window.innerWidth <= 991) {
            $owlAttr.autoplay = self.autoplayMobile;
            $owlAttr.lazyLoadEager = 0;
          }
          $owl.owlCarousel($owlAttr);
        });
      } else if (i < i_max) {
        let timeForTimeout = 200 + (Math.pow(i, 3) * 8);
        setTimeout(function () {
          ++i;
          self.owlCarouselStart(i_max, i, $owl, $owlAttr);
        }, timeForTimeout);
      }
    }
  },
  mounted: function () {
    let $owlAttr = {
      items: this.items,
      margin: this.margin,
      loop: this.loop,
      rewind: this.rewind,
      center: this.center,
      nav: this.nav,
      navText: this.navText,
      navSpeed: this.navSpeed,
      dots: this.dots,
      autoplay: this.autoplay,
      mouseDrag: this.mouseDrag,
      touchDrag: this.touchDrag,
      pullDrag: this.pullDrag,
      freeDrag: this.freeDrag,
      dragEndSpeed: this.dragEndSpeed,
      stagePadding: this.stagePadding,
      autoWidth: this.autoWidth,
      autoHeight: this.autoHeight,
      responsive: this.responsive,
      lazyLoad: this.lazyLoad,
      lazyLoadEager: this.lazyLoadEager
    };

    if (this.autoplay) {
      $.extend($owlAttr, {
        autoplaySpeed: this.autoplaySpeed,
        autoplayTimeout: this.autoplayTimeout,
        autoplayHoverPause: this.autoplayHoverPause
      });
    }

    const self = this;
    self.owlCarouselStart(10, 0, $('#' + self.elementHandle), $owlAttr);
  }
});
